<template>
    <div @click="toggleCheck" class="flex justify-start items-center mb-6">
        <div class="flex justify-center items-center border border-gray-400 w-6 h-6 cursor-pointer" :class="{ 'border-green-400':value }">
            <span v-if="value">
                <font-awesome-icon
                    icon="check"
                    class="text-md text-green-400 relative"
                />
            </span>
        </div>
        <span class="ml-2">{{ label }}</span>
        <input
            type="hidden"
            :name="name"
            :value="value">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                checked: false,
            }
        },
        props: ['value', 'label', 'name', 'default'],
        methods: {
            toggleCheck() {
                this.checked = !this.checked
                this.$emit('input', this.checked)
            }
        },
        mounted() {
            if(this.default) {
                console.log('default');
                this.checked = this.default
            }
        },
    }
</script>